var render = function render(){var _vm=this,_c=_vm._self._c;return _c('form',{ref:"paygateForm",attrs:{"action":"https://secure.paygate.co.za/payweb3/process.trans","method":"POST"}},[_c('input',{attrs:{"type":"hidden","name":"PAY_REQUEST_ID"},domProps:{"value":_vm.paygateResponse.pay_request_id}}),_vm._v(" "),_c('input',{attrs:{"type":"hidden","name":"CHECKSUM"},domProps:{"value":_vm.paygateResponse.checksum}})])
}
var staticRenderFns = []

export { render, staticRenderFns }